import { handleActions } from 'redux-actions';
import { v4 as uuidv4 } from 'uuid';

import { coreActions } from '../core-actions';

import * as actions from './postponedActionsActions';
import { mkPostponedAction, mkPostponedActionsStore } from './postponedActionsTypes';

export const reducer = handleActions(
  {
    [coreActions.sanitize]: (state) => state.delete('postponedActions'),

    [actions.addPostponedAction]: (state, { payload }) => {
      const { action } = payload;
      if (
        assert(action, 'addPostponedAction: action required') &&
        payload.maxAttempts &&
        (action.meta === undefined || action.meta.attemptsLeft === undefined)
      ) {
        action.meta = action.meta || {};
        action.meta.attemptsLeft = payload.maxAttempts;
      }
      return state.merge({
        postponedActions: state.postponedActions.push(
          mkPostponedAction({
            action,
            error: payload.error,
            onFailure: payload.onFailure,
            maxAttempts: payload.maxAttempts,
            key: uuidv4(),
          }),
        ),
      });
    },
    [actions.dispatchPostponedActions]: (state, { payload: postponedActions }) => {
      assert(postponedActions, 'dispatchPostponedActions: postponedActions required');
      return state.merge({
        postponedActions: state.postponedActions.filterNot((postponedAction) =>
          postponedActions?.includes(postponedAction),
        ),
      });
    },
    [actions.dismissPostponedActions]: (state, { payload: postponedActions }) => {
      assert(postponedActions, 'dismissPostponedActions: postponedActions required');
      return state.merge({
        postponedActions: state.postponedActions.filterNot((postponedAction) =>
          postponedActions?.includes(postponedAction),
        ),
      });
    },
  },
  mkPostponedActionsStore(),
);

export default reducer;
